import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(frontend)/globals.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/(frontend)/[[...slug]]/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../fonts/GT-Planar-Regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../fonts/GT-Planar-Italic-15-Regular.woff2\",\"weight\":\"400\",\"style\":\"italic\"},{\"path\":\"../fonts/GT-Planar-Bold.woff2\",\"weight\":\"700\",\"style\":\"normal\"},{\"path\":\"../fonts/GT-Planar-Italic-15-Bold.woff2\",\"weight\":\"700\",\"style\":\"italic\"},{\"path\":\"../fonts/GT-Planar-Light.woff2\",\"weight\":\"300\",\"style\":\"normal\"},{\"path\":\"../fonts/GT-Planar-Italic-15-Light.woff2\",\"weight\":\"300\",\"style\":\"italic\"},{\"path\":\"../fonts/GT-Planar-Thin.woff2\",\"weight\":\"250\",\"style\":\"normal\"}]}],\"variableName\":\"GTPlanar\"}");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionBlock"] */ "/vercel/path0/src/blocks/AccordionBlock/Component.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/blocks/ButtonGroupBlock/block.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/blocks/CodeBlock/block.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/blocks/BlockSettings.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["CopyCodeButton"] */ "/vercel/path0/src/blocks/CodeBlock/CopyCodeButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmbedBlock"] */ "/vercel/path0/src/blocks/EmbedBlock/Component.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/blocks/IntroductoryParagraphBlock/block.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/blocks/MediaBlock/block.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["TextElementBlock"] */ "/vercel/path0/src/blocks/TextElementBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedBlob"] */ "/vercel/path0/src/components/AnimatedBlob/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackgroundGradient"] */ "/vercel/path0/src/components/BackgroundGradient/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/vercel/path0/src/components/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Link/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/RichText/RichText.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AdminBar"] */ "/vercel/path0/src/components/utilities/AdminBar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTMInjector"] */ "/vercel/path0/src/components/utilities/Analytics/GTMInjector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/vercel/path0/src/components/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackgroundColorProvider"] */ "/vercel/path0/src/contexts/BackgroundColorContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FrontPageEffectProvider"] */ "/vercel/path0/src/contexts/FrontPageEffectContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ColumnSocial"] */ "/vercel/path0/src/globals/Footer/ColumnSocial.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/globals/Footer/Footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderClient"] */ "/vercel/path0/src/globals/Header/ComponentClient.tsx");
